// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__ua8Np","col":"ProductsDashboard_col__uCodX","card":"ProductsDashboard_card__VyOlr"};